import type { GaugeScaleType } from "./types";

/** Canonical order of Scale Max options shown in the gauge configurator dropdown. */
export const GAUGE_SCALE_TYPES: GaugeScaleType[] = [
  "player_avg",
  "player_best",
  "player_sum",
  "position_avg",
  "position_best",
  "position_sum",
  "team_avg",
  "team_best",
  "team_sum",
  "baseline_multiplier",
  "custom",
];

/** Display labels for each gauge scale type — single source of truth shared by the
 *  configurator form, the preview panel, and the rendered widget. The form renders a
 *  separate "× <multiplier>" input next to baseline_multiplier, so its label stays "Baseline". */
export const SCALE_TYPE_LABELS: Record<GaugeScaleType, string> = {
  player_avg: "Player Average",
  player_best: "Player Best",
  player_sum: "Player Sum",
  position_avg: "Position Average",
  position_best: "Position Best",
  position_sum: "Position Sum",
  team_avg: "Team Average",
  team_best: "Team Best",
  team_sum: "Team Sum",
  baseline_multiplier: "Baseline",
  custom: "Custom",
};
